const data = {
  id: 1,
  title: 'Choose the correct word form to fill in the sentence.',
  subTitle: 'Chọn dạng từ phù hợp để điền vào chỗ trống trong câu.',
  question: 'If the three parties cannot reach ___ now, there will be a civil war.',
  answers: [
    { id: 1, answer: 'agreeable', isCorrect: false },
    { id: 2, answer: 'agreement', isCorrect: true },
    { id: 3, answer: 'agreeably', isCorrect: false },
  ],
};

export default data;
